<div id="header">
  <mat-form-field>
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Recherche">
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>

<table mat-table [dataSource]="davs">

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td class="list-actions-1" mat-cell *matCellDef="let dav">
      <mat-icon id="edit-button" matSuffix>edit</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="site">
    <th mat-header-cell *matHeaderCellDef> Site d'affectation </th>
    <td mat-cell *matCellDef="let dav"> {{dav.site.numero}} - {{dav.site.region}} </td>
  </ng-container>

  <ng-container matColumnDef="nom">
    <th mat-header-cell *matHeaderCellDef> Nom du DAV </th>
    <td mat-cell *matCellDef="let dav"> {{dav.nom}} </td>
  </ng-container>

  <ng-container matColumnDef="partenaire">
    <th mat-header-cell *matHeaderCellDef> Partenaire </th>
    <td mat-cell *matCellDef="let dav"> {{dav.partenaire}} </td>
  </ng-container>

  <ng-container matColumnDef="adresse_serveur">
    <th mat-header-cell *matHeaderCellDef> Nom du serveur </th>
    <td mat-cell *matCellDef="let dav"> {{dav.adresse_serveur}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let dav; columns: displayedColumns;" (click)="editDav(dav)"></tr>

</table>